<template>
  <div :class="['row', $isDesktop ? 'q-col-gutter-lg' : 'q-col-gutter-md']">
    <div class="col-12 col-sm-6 col-xl-4" :class="$isDesktop ? 'q-gutter-lg' : 'q-gutter-md'">
      <common-input
          v-model="form.title"
          label="Naam"
          name="title"
          :error-message="$errorMessage('title')"
          :error="$hasError('title')"
          required
      />
      <common-input
          v-model="form.type"
          label="Type"
          name="type"
          :error-message="$errorMessage('type')"
          :error="$hasError('type')"
      />
      <common-select
          v-model="form.object_group_id"
          map-options
          required
          name="object_group_id"
          :error-message="$errorMessage('object_group_id')"
          :error="$hasError('object_group_id')"
          :options="objectGroupsArray"
          label="Selecteer subcategorie" />
    </div>
    <div class="col-12 col-sm-6 col-xl-4" :class="$isDesktop ? 'q-gutter-lg' : 'q-gutter-md'">
      <common-input
          v-model="form.color"
          label="Kleur"
          name="color"
          :error-message="$errorMessage('color')"
          :error="$hasError('color')"
      />
      <common-input
          v-model="form.dimensions"
          label="Specificaties"
          name="dimensions"
          :error-message="$errorMessage('dimensions')"
          :error="$hasError('dimensions')"
      />
      <common-input
          v-model="form.material"
          label="Materiaal"
          name="material"
          :error-message="$errorMessage('material')"
          :error="$hasError('material')"
      />
    </div>
    <div class="col-12 col-sm-6 col-xl-4" :class="$isDesktop ? 'q-gutter-lg' : 'q-gutter-md'">
      <common-input
          v-model="form.supplier"
          label="Mogelijke leveranciers"
          name="supplier"
          :error-message="$errorMessage('supplier')"
          :error="$hasError('supplier')"
      />
    </div>
  </div>
  <div class="row q-mt-lg">
    <div class="col-12">
      <common-input
          v-model="form.requirements"
          label="Uitvoeringsvoorschriften"
          name="requirements"
          type="textarea"
          :error-message="$errorMessage('requirements')"
          :error="$hasError('requirements')"
          required
      />
    </div>
  </div>
  <div class="row q-mt-lg">
    <div class="col-12 text-weight-medium">Categorie&euml;n</div>
    <item-selection
        v-model="form.categories"
        label="Categorie&euml;n"
        :rows="2"
        :error-message="$errorMessage('categories')"
        :error="$hasError('categories')"
        :items="categories"
        name="categories[]" />
  </div>
  <map-selection :mapIds="form.mapIds" />
</template>

<script>
export default {
  props: {
    object: {
      type: Object,
      default: () => ({}),
    },
    objectGroups: {
      type: Object,
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      form: {
        title: this.$old('title', this.object?.title),
        type: this.$old('type', this.object?.type),
        color: this.$old('color', this.object?.color),
        dimensions: this.$old('dimensions', this.object?.dimensions),
        material: this.$old('material', this.object?.material),
        requirements: this.$old('requirements', this.object?.requirements),
        object_group_id: this.$old('object_group_id', this.object?.object_group_id),
        supplier: this.$old('supplier', this.object?.supplier),
        categories: this.$old('categories', this.object?.categories || [])
            .map(category => parseInt(category?.id || category)),
        mapIds: this.$old('maps', this.object?.maps || [])
            .map(map => parseInt(map?.id || map)),
      },
    }
  },
  computed: {
    objectGroupsArray () {
      return this.objectGroups.map((group) => {
        return {
          value: group.id,
          label: group.title,
        }
      })
    },
    categoriesArray () {
      return this.categories.map((category) => {
        return {
          value: category.id,
          label: category.title,
        }
      })
    },
    categorySettings () {
      return this.object.categories.map((category) => {
        return category.id
      })
    },
  },
}
</script>

